import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function MobileHeader({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isAccountPage = location.pathname === '/account';

  return (
    <div className="mobile-header">
      {isAccountPage ? (
        <button
          className="mobile-header-back-button"
          onClick={() => navigate('/')}
          aria-label="Back to lists"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 16l-6-6 6-6M6 10h11" />
          </svg>
          <span>Back to Lists</span>
        </button>
      ) : (
        <>
          <div className="mobile-header-brand">
            <div className="mobile-header-brand-content">
              <img src="/logo_big.png" alt="Windmill" className="mobile-header-logo" />
              <div className="mobile-header-brand-text">
                <h1 className="mobile-header-title">Windmill</h1>
                <p className="mobile-header-tagline">Get stuff done</p>
              </div>
            </div>
          </div>
          <div className="mobile-header-actions">
            <button 
              className="mobile-header-icon-btn" 
              aria-label="Account"
              onClick={() => navigate('/account')}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="10" cy="7" r="3" />
                <path d="M3 18c0-3.866 3.134-7 7-7s7 3.134 7 7" />
              </svg>
            </button>
            <button 
              className="mobile-header-icon-btn" 
              aria-label="Logout"
              onClick={onLogout}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M13 3h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3M8 16l-5-5 5-5M3 11h11" />
              </svg>
            </button>
          </div>
        </>
      )}
    </div>
  );
}



